"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var DEFAULT_QUILL_DELTA = {
    ops: [
        {
            insert: '\n'
        }
    ]
};
/**
 * This file is almost completely redundant. Essentially, it stores the quill editor's content
 * using setContents, and then those contents are pulled via getContents in multiple other files.
 *
 * Since it is difficult to access the quill object outside of the modal, this was used as
 * a hacky way to pull the content instead of getting it from the environment.
 */
var PageHeaderFooterOptionsService = /** @class */ (function () {
    function PageHeaderFooterOptionsService() {
        this.headerContents = lodash_1.default.cloneDeep(DEFAULT_QUILL_DELTA);
        this.footerContents = lodash_1.default.cloneDeep(DEFAULT_QUILL_DELTA);
        this.isSaveInProgress = false;
    }
    PageHeaderFooterOptionsService.prototype.getContents = function (headerFooter) {
        return headerFooter === 'header' ? this.headerContents : this.footerContents;
    };
    PageHeaderFooterOptionsService.prototype.setContents = function (headerFooter, value) {
        if (headerFooter === 'header') {
            this.headerContents = value;
        }
        else {
            this.footerContents = value;
        }
    };
    PageHeaderFooterOptionsService.prototype.setSaveInProgress = function (value) {
        this.isSaveInProgress = value;
    };
    PageHeaderFooterOptionsService.prototype.isSavingInProgress = function () {
        return this.isSaveInProgress;
    };
    return PageHeaderFooterOptionsService;
}());
(function (angularModule) {
    angularModule.service('prPageHeaderFooterOptionsService', PageHeaderFooterOptionsService);
})(angular_1.module('qualtrics.pr'));
